var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabSettingsEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#36F6FF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35699 14.714L16.337 19.368C17.3 20.009 17.781 20.33 18.301 20.455C18.761 20.565 19.24 20.565 19.699 20.455C20.219 20.33 20.7 20.009 21.663 19.368L28.643 14.714M14.157 26.5H23.843C25.523 26.5 26.363 26.5 27.005 26.173C27.5691 25.8852 28.0276 25.4263 28.315 24.862C28.643 24.22 28.643 23.38 28.643 21.7V16.3C28.643 14.62 28.643 13.78 28.316 13.138C28.0284 12.5735 27.5695 12.1146 27.005 11.827C26.363 11.5 25.523 11.5 23.843 11.5H14.157C12.477 11.5 11.637 11.5 10.995 11.827C10.4309 12.1148 9.97235 12.5737 9.68499 13.138C9.35699 13.78 9.35699 14.62 9.35699 16.3V21.7C9.35699 23.38 9.35699 24.22 9.68399 24.862C9.97161 25.4265 10.4305 25.8854 10.995 26.173C11.637 26.5 12.477 26.5 14.157 26.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabSettingsEmailIcon);
export default __webpack_public_path__ + "static/media/tc_cab_settings_email_icon.2f0597fc44be0df63747e60b64f4fffe.svg";
export { ForwardRef as ReactComponent };